import * as React from "react"
export const EmptyChat = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={93} height={83} viewBox="0 0 93 83" fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M59.279 27.732v8.066h2.013v-8.066l5.703 5.704 1.423-1.424-5.703-5.703h8.066v-2.013h-8.066l5.703-5.704-1.423-1.423-5.703 5.704v-8.066h-2.013v8.066l-5.704-5.704-1.423 1.423 5.703 5.704H49.79v2.013h8.066l-5.703 5.703 1.423 1.424 5.704-5.704ZM46.425 43.85a27.101 27.101 0 0 0-24.53 15.547l-1.82-.858a29.115 29.115 0 0 1 52.685.028l-1.822.856A27.103 27.103 0 0 0 46.425 43.85ZM32.536 35.798c5.797 0 10.496-4.699 10.496-10.496 0-5.796-4.7-10.495-10.496-10.495-5.797 0-10.496 4.699-10.496 10.495 0 5.797 4.7 10.496 10.496 10.496ZM39.2 20.103l-6.52-3.14-6.52 3.14-1.61 7.055 4.512 5.658h7.236l4.512-5.658-1.61-7.055Z"
      clipRule="evenodd"
    />
    <path stroke="#000" strokeWidth={2} d="M1 1.088h91v72.06H23.75l-11.375 7.764V73.15H1V1.088Z" />
  </svg>
)
